import { SaveBoostInputjajsjdtwe7t7 as SaveBoostInput } from './schema/type/SaveBoostInput.mjs';
import { SaveBoostMutation360x4uh5hti27 as SaveBoostMutation } from './schema/SaveBoostMutation.mjs';
import {
  Unknown23h9hhg1mgr7w as Unknown,
  Dispatcher3ngwv5mtnm33a as Dispatcher,
} from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/ApplyBoostCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function saveBoostInput($this, $receiver) {
  return new (SaveBoostInput())($receiver.a2j_1);
}
function *perform(command, $completion) {
  // Inline function 'kotlin.let' call
  yield* this.i6s(new (SaveBoostMutation())(saveBoostInput(this, command)), $completion);
  return new (Unknown())('whoops');
}
var SdkBoostClass;
function SdkBoost() {
  if (SdkBoostClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkBoost', VOID, VOID, [GqlTrait(), Dispatcher()], [1, 0]);
    SdkBoostClass = $;
  }
  return SdkBoostClass;
}
//region block: exports
export {
  SdkBoost as SdkBoost3eue7fgosgz0d,
  perform as perform1rf0a2z80o7fg,
};
//endregion

//# sourceMappingURL=SdkBoost.mjs.map
